import React from 'react';
import {
  Create,
  SimpleForm,

  TextInput,
  SelectInput,
} from 'react-admin';
import { ADMIN_LEVELS } from '../../authProvider';

const roleChoices = [
  { id: ADMIN_LEVELS.FULL_ADMIN, name: 'Full Admin' },
  { id: ADMIN_LEVELS.SUPERVISOR_ADMIN, name: 'Supervisor Admin' },
  { id: ADMIN_LEVELS.REGULAR_ADMIN, name: 'Regular Admin' },
  { id: ADMIN_LEVELS.READ_ONLY_ADMIN, name: 'Read Only Admin' },
  { id: null, name: 'None' },
];

export default props => (
  <Create
    {...props}
    title="Create User"
  >
    <SimpleForm redirect="list">
      <TextInput label="Email" source="email" />
      <TextInput label="Password" source="passphrase" />
      <SelectInput label="Role" source="role" choices={roleChoices} optionText="name" optionValue="id" />
    </SimpleForm>
  </Create>
);




// WEBPACK FOOTER //
// ./src/components/User/Create.jsx